import { MeRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

let _userRestService;
let _util;

const _serviceDependencies = ['$scope', 'UserRestService',
    'Util', 'Auth', '$rootScope'];

/**
 * @ngdoc service
 * @name controllers.SetPassword
 *
 * @description
 * SetPassword controller
 */
class SetPassword {

    constructor(
        $scope, UserRestService,
        Util, Auth,
        $rootScope,
    ) {

        $rootScope.State.finishedLoadingAnimation = true;

        this.$scope = $scope;
        this.$scope.passwordRegExp = Util.getPasswordValidationRegExp();
        this.Auth = Auth;
        this.$rootScope = $rootScope;
        this.Auth.loading = false;
        this.MeRepository = MeRepository;

        _userRestService = UserRestService;
        _util = Util;

        let mixpanelPayload = { Source: 'Direct' };

        if ($rootScope.isFromSpotlightNewsletterCampaign === true) {

            mixpanelPayload = { Source: 'ws_spotlight' };

        }

        Mixpanel.send('ConnectWeb Auth Set Password Open', mixpanelPayload);

        $scope.user = {
            email: this.MeRepository.getMyEmail(),
            password: '',
        };
        this.passwordScore = {};

    }

    setPassword() {

        const userId = this.MeRepository.getMyId();

        this.$scope.submitted = true;
        this.$scope.setPasswordForm.$setValidity('serverValidation', true);

        Mixpanel.send('ConnectWeb Set Password Click');

        const payload = {
            data: {
                attributes: {
                    password: this.$scope.user.password,
                },
                type: 'users',
                id: userId,
            },
        };

        this.getPasswordScore(this.$scope.user.password);

        const formIsValid = this.$scope.setPasswordForm.$valid && this.passwordScore.valid;

        if (formIsValid) {

            this.Auth.loading = true;

            _userRestService.update(userId, payload)
                .then((response) => {

                    this.MeRepository.update(response.data.data);

                })
                .then(null, () => {

                    this.Auth.loading = false;

                    this.$scope.setPasswordForm.$setValidity('serverValidation', false);
                    _util.triggerAnimation('.error', 'animated shake');

                });

        } else {

            _util.triggerAnimation('.error', 'animated shake');

        }

    }

    showPassword() {

        const inputType = angular.element('#password')[0];

        if (inputType.type === 'text') {

            inputType.type = 'password';

        } else {

            inputType.type = 'text';

        }

        this.$scope.inputType = inputType.type;

    }

    getPasswordScore(password) {

        this.passwordScore = _util.getPasswordScore(password);

    }

}

_serviceDependencies.push(SetPassword);

angular.module('controllers')
    .controller('SetPassword', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/controllers/auth/set-password/set-password.js